// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from "../locales/english.json";
import translationFrench from "../locales/french.json";
import translationArabic from "../locales/arabic.json";
import translationPortuguese from "../locales/portuguese.json";
import translationSwahili from "../locales/swahili.json";
import translationAmharic from "../locales/amharic.json";
import translationEspanish from "../locales/spanish.json";
import translationSinhala from "../locales/sinhala.json";
import translationTokPisin from "../locales/tok-pisin.json";
import translationKikingo from "../locales/kikingo.json";
import translationBahasa from "../locales/bahasa.json";
import translationKhmer from "../locales/khmer.json";
import translationRussian from "../locales/russian.json";
import translationOromo from "../locales/oromo.json";
import translationShona from "../locales/shona.json";
import translationTamil from "../locales/tamil.json";
// import { getFunFact } from "../http/http";

// const response = await getFunFact();

// let totalFacts = 0;
// response?.data?.result?.forEach((element, i) => {
//     totalFacts = totalFacts + 1;
//     translationEnglish = { ...translationEnglish, [`fun_fact_${i + 1}`]: element.english };
//     translationFrench = { ...translationFrench, [`fun_fact_${i + 1}`]: element.french };
//     translationArabic = { ...translationArabic, [`fun_fact_${i + 1}`]: element.arabic };
//     translationPortuguese = { ...translationPortuguese, [`fun_fact_${i + 1}`]: element.portuguese };
//     translationSwahili = { ...translationSwahili, [`fun_fact_${i + 1}`]: element.swahili };
//     translationAmharic = { ...translationAmharic, [`fun_fact_${i + 1}`]: element.amharic };
//     translationEspanish = { ...translationEspanish, [`fun_fact_${i + 1}`]: element.spanish };
//     translationShona = { ...translationShona, [`fun_fact_${i + 1}`]: element.shona };
//     translationTokPisin = { ...translationTokPisin, [`fun_fact_${i + 1}`]: element.tokPisin };
//     translationKikingo = { ...translationKikingo, [`fun_fact_${i + 1}`]: element.kikongo };
//     translationBahasa = { ...translationBahasa, [`fun_fact_${i + 1}`]: element.bahasa };
//     translationKhmer = { ...translationKhmer, [`fun_fact_${i + 1}`]: element.khmer };
//     translationRussian = { ...translationRussian, [`fun_fact_${i + 1}`]: element.russian };
//     translationOromo = { ...translationOromo, [`fun_fact_${i + 1}`]: element.oromo };
//     translationSinhala = { ...translationSinhala, [`fun_fact_${i + 1}`]: element.sinhala };
//     translationTamil = { ...translationTamil, [`fun_fact_${i + 1}`]: element.tamil };
// });

// localStorage.setItem("total_facts", totalFacts);

const resources = {
    0: {
        translation: translationEnglish
    },
    1: {
        translation: translationFrench
    },
    2: {
        translation: translationArabic
    },
    3: {
        translation: translationPortuguese
    },
    4: {
        translation: translationSwahili
    },
    5: {
        translation: translationAmharic
    },
    6: {
        translation: translationEspanish
    },
    7: {
        translation: translationShona
    },
    8: {
        translation: translationTokPisin
    },
    9: {
        translation: translationKikingo
    },
    10: {
        translation: translationBahasa
    },
    11: {
        translation: translationKhmer
    },
    12: {
        translation: translationRussian
    },
    13: {
        translation: translationOromo
    },
    14: {
        translation: translationSinhala
    },
    15: {
        translation: translationTamil
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: "0", // default language
    interpolation: {
        escapeValue: false // react already escapes values
    }
});

export default i18n;
